import { HoursOfBase } from './hours-of-base';

export class HoursOfOperation extends HoursOfBase {
  
    parentHoO: HoursOfOperation;

    parentHoOId: string;
}
